{
    "OninboundalertingPara": "You can activate alarms when inbound calls alert for too long.",
    "OntalktimePara": "You can also activate alarms when any call reaches a talk time threshold.",
    "OninboundalertingLabel": "On Inbound Alerting Over:",
    "OntalktimeLabel": "On Talk Time Over:",
    "OninboundalertingEnabledHiddenlabel": "Is On Inbound Alerting Over Setting Enabled?",
    "OntalktimeEnabledHiddenlabel": "Is On Talk Time Over Setting Enabled?",
    "OninboundalertingPlaceholder": "15s",
    "OntalktimePlaceholder": "5m 0s",
    "NAME": "CallStateThresholds",
    "CallStateThresholds_SectionHeader": "Call State Thresholds"
}